import { render, staticRenderFns } from "./PromotionItemSidebar.vue?vue&type=template&id=04fb1405&"
import script from "./PromotionItemSidebar.vue?vue&type=script&lang=js&"
export * from "./PromotionItemSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04fb1405')) {
      api.createRecord('04fb1405', component.options)
    } else {
      api.reload('04fb1405', component.options)
    }
    module.hot.accept("./PromotionItemSidebar.vue?vue&type=template&id=04fb1405&", function () {
      api.rerender('04fb1405', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/promotion/PromotionItemSidebar.vue"
export default component.exports